<template>
  <div>
    <!--头部-->
    <div class="home_top">
      <!--logo-->
      <div class="home_top_logo">
        <!--左 logo区-->
        <div class="home_logo_left">
          <img src="../assets/images/home/logo.png" alt="">
        </div>
        <!--右 搜索-->
        <div v-if="0" class="home_seek_right">
          <div class="home_seek_box">
            <img src="../assets/images/home/seek.png" alt="">
            <input type="text" placeholder="请输入关键字搜索" v-model="value">
            <div style="display: none" class="home_seek_list">
              <ul>
                <li>今天是个好日子</li>
                <li>今天是个好日子</li>
              </ul>
            </div>
          </div>
          <div class="home_seek_button" @click="handleSearch">搜索</div>
        </div>
      </div>
      <!--导航-->
      <div class="home_top_nav">
        <div class="home_top_navList">
          <div class="item_list" :class="{active:$route.path == '/' ||$route.path.indexOf('/search')>=0 }" @click="$router.replace(type=='tt'?'/tt/index'+'.html':'/')">
            <img src="../assets/images/home/home.png" alt="">首页
          </div>
          <div class="mask_li"></div>
          <!--<li :class="{active:$route.path.indexOf('/diseaseList')>=0 ||$route.path.indexOf('/diseaseShow')>=0 } " @click="$router.replace('/diseaseList')">疾病百科</li>-->
          <div class="item_list" :class="{active:$route.path.indexOf('/kpVideo')>=0}" @click="$router.replace(type=='tt'?'/tt/kpVideo'+'.html':'/kpVideo')">科普视频</div>
          <div class="mask_li"></div>
          <div class="item_list" :class="{active:$route.path.indexOf('/kpVoice')>=0}" @click="$router.replace(type=='tt'?'/tt/kpVoice'+'.html':'/kpVoice')">科普语音</div>
          <div class="mask_li"></div>
          <!--<li :class="{active:$route.path.indexOf('/kpArticle')>=0}" @click="$router.replace('/kpArticle')">科普文章</li>-->
          <div class="item_list" :class="{active:$route.path.indexOf('/salientDoctor')>=0}" @click="$router.replace(type=='tt'?'/tt/salientDoctor'+'.html':'/salientDoctor')">三甲名医</div>
          <div class="mask_li"></div>
          <div class="item_list" :class="{active:$route.path.indexOf('/answerList')>=0}" @click="$router.replace(type=='tt'?'/tt/answerList'+'.html':'/answerList')">互动问答</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Header",
    data(){
      return {
        value:null,
        type:''
      }
    },
    created(){
      this.type=this.$route.path.split('/')[1]
      console.log(this.type)

    },
    methods:{
      handleSearch() {
        this.$router.push({path:'/search',query:{val:this.value,id:1}})
      }
    },
  }
</script>
<style lang="stylus" scoped>
  div{
    box-sizing border-box
  }
  input{
    border:none
    &:focus {
      outline: none;
      background:none;
      border:0
    }
  }
  /*头部*/
  .home_top {

    .home_top_logo {
      width 1200px
      height 75px
      margin 0 auto
      display flex
      align-items center
      .home_logo_left{
        cursor: pointer
        >img {
          width 250px
          height:48px
        }
      }
      .home_seek_right{
        display flex
        margin-left 300px
        .home_seek_box {
          width 336px
          height 40px
          border 1px solid #e4e4e4
          display flex
          align-items center
          position relative
          >img {
            margin-left 15px
          }
          >input{
            height 35px
            width 260px
            margin-left 15px
          }
          .home_seek_list {
            position absolute
            top:38px
            left 0
            z-index 5
            width 336px
            background #fff
            border:1px solid #eee
            >ul{
              max-height 250px
              overflow:auto
              >li{
                padding-left 10px
                height:30px
                display flex
                align-items center
                font-size 14px
                &:hover {
                  background #0d83f8
                }
                &:first-child{
                  margin-top 8px
                }
              }
            }
          }
        }
        .home_seek_button {
          width: 100px
          height:40px
          color: #ecf4fe
          font-size:18px
          font-weight 700
          background #0d83f8
          display flex
          align-items center
          justify-content center
        }
      }
    }
    .home_top_nav {
      width 100%
      height 64px
      background #0d83f8
      .home_top_navList {
        width:1200px
        height 64px
        margin 0 auto
        display flex
        justify-content space-between
        align-items center
        .item_list {
          cursor: pointer
          position relative
          font-size 20px
          color: #fff
          font-weight 400
          display flex
          align-items center
          height: 21px
          &:before{
            content: ''
            width 80px
            height 4px
            display none
            position absolute
            left: 0
            bottom -21.5px
            background #fff
          }

          &:last-child{
            &:after{
              display none
            }
          }
          &:first-child {
            display flex
            align-items center
            &:first-line{
              content ''
              width 20px
              height 20px
              background-image url("../assets/images/home/home.png")
              background-size 20px 20px
              background-repeat no-repeat
              background-position 0 -3px
              padding-right 5px
              display block
            }
            &:before{
              width: 60px
              margin-left 5px
            }
          }
          &.active{
            &:before{
              display block
            }
          }
          >img{
            width: 24px
            height: 24px
            vertical-align middle
            transform translateY(-1px)
            margin-right 4px
          }
        }
        .mask_li{
          width: 1px
          height: 21px
          background #fff
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/Header.vue